import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'
import { IPkRateHistory } from '../models/models'

export class ListPkRateHistoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/pesineKontrat/listRateHistory',
      requesterInfo,
    })
  }

  public async listRateHistory(guid: string): Promise<IPkRateHistory[]> {
    this.props.url = `${this.props.url}?guid=${encodeURIComponent(guid)}`
    return await this.getAsync<IPkRateHistory[]>()
  }
}
